import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Sheet from '../ui/Sheet';
import Icon from '../ui/Icon';
import { getMoreNav, isNavItemActive } from './adminNav';
import { useAdminShell } from './AdminContext';

/** The phone/tablet navigation drawer — every destination the top nav shows on desktop, as one list. */
export default function AdminNavSheet() {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  const { isSuper, navOpen, closeNav } = useAdminShell();
  const nav = getMoreNav(isSuper);

  const go = (path) => { closeNav(); navigate(path); };

  return (
    <Sheet open={navOpen} onClose={closeNav} title="More">
      <nav className="az-navsheet" aria-label="Primary">
        {nav.map(item => {
          const active = isNavItemActive(item, pathname, search);
          return (
            <button key={item.path} type="button" className={`az-navsheet-item${active ? ' active' : ''}`} aria-current={active ? 'page' : undefined} onClick={() => go(item.path)}>
              <Icon name={item.icon} size={20} />
              <span>{item.label}</span>
            </button>
          );
        })}
      </nav>
    </Sheet>
  );
}
